import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const accessApi = createApi({
  reducerPath: 'Access',
  tagTypes: ['Access'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getPayorsUsers: builder.query({
      query: ({ page, size, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/users/payors?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    createOrUpdatePayorsUsers: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/users/payors/${id ? `update/${id}` : 'create'}`,
        method: id ? 'PUT' : 'POST',
        body: data,
      }),
    }),
    getPayorMobileInfo: builder.query({
      query: () => ({ url: '/v1/company/apps' }),
    }),
    getPlacesUsers: builder.query({
      query: ({ page, size, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/users/places/place?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    getContractorsUsers: builder.query({
      query: ({ page, size, sortBy = 'id', sortDir = 'desc' }) => ({
        url: `/v1/users/contractor?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),
    createOrUpdateContractorsUsers: builder.mutation({
      query: ({ id, data }) => ({
        url: `/v1/users/contractor/${id ? `update/${id}` : 'create'}`,
        method: id ? 'PUT' : 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLazyGetPayorsUsersQuery,
  useCreateOrUpdatePayorsUsersMutation,
  useLazyGetPlacesUsersQuery,
  useLazyGetPayorMobileInfoQuery,
  useLazyGetContractorsUsersQuery,
  useCreateOrUpdateContractorsUsersMutation,
} = accessApi;
